import {ModuleState} from '@fantasmagames/slot/src/common/ModuleState';
import {FlowModule} from '@fantasmagames/slot/src/modules/flow/FlowModule';
import {LogicEvents} from '@fantasmagames/slot/src/logic/LogicEvents';
import {QueueEventsHandler} from '@fantasmagames/slot/src/modules/flow/states/QueueEventsHandler';
import {IEventManagerWithAsync} from '@fantasmagames/core/src/events/_interfaces/IEventManager';
import {Action} from '@fantasmagames/slot/src/logic/Action';
import {FlowModuleEvents} from '@fantasmagames/slot/src/modules/flow/FlowModuleEvents';
import {BonusGameEvents} from '@fantasmagames/slot/src/modules/bonus/BonusGameEvents';

export class FlowBonusState extends ModuleState<null, FlowModule> {
	protected _queueEvents: QueueEventsHandler;

	constructor(module: FlowModule, name: string, eventManager: IEventManagerWithAsync) {
		super(module, name);
		this._queueEvents = new QueueEventsHandler(eventManager);
	}

	public onEnterState(): void {
	}

	public onLeaveState(): void {
	}

	protected setupEvents(): void {
		this.on(LogicEvents.PICK_RESPONSE, this.onBonusGamePick);
		this.on(LogicEvents.SKIPPICK_RESPONSE, this.onBonusGamePick);
		this.on(BonusGameEvents.BONUS_OUTRO_FINISHED, this.onBonusOutroFinished);
	}

	protected onBonusGamePick(pickData: any): void {
		this._queueEvents.clearEventsQueue();

		if (this.module.logic.nextAction !== Action.PICK) {
			this._queueEvents.addEventToWaitingList(
				BonusGameEvents.WIN_RESULT_SHOWN,
				FlowModuleEvents.BONUS_GAME_END,
			);
		}
	}

	protected onBonusOutroFinished(): void {
		this.emit(FlowModuleEvents.CAN_SPIN);
		switch (this.module.logic.nextAction) {
			case Action.SPIN: {
				this.setupNextStateSpin();
				break;
			}

			case Action.FREESPIN: {
				this.setupNextStateFreeSpin();
				break;
			}

			case Action.RESPIN: {
				this.setupNextStateRespin();
				break;
			}
			case Action.AVALANCHE: {
				this.setupNextStateAvalanche();
				break;
			}

			default:
				break;
		}
	}

	protected setupNextStateSpin(): void {
		this.module.gotoState(FlowModule.BASIC_STATE);
	}

	protected setupNextStateFreeSpin(): void {
		this.module.gotoState(FlowModule.FREE_SPINS_STATE);
	}

	protected setupNextStateRespin(): void {
		this.module.gotoState(FlowModule.RESPIN_STATE);
	}

	protected setupNextStateAvalanche(): void {
		this.module.gotoState(FlowModule.AVALANCHE_STATE);
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/flow/states/FlowBonusState.ts